export interface WorkshopForm {
  name: string
  address: string
  phone: string
  email: string
}

export interface WorkshopFormErrors {
  name: 'required' | 'taken' | null
  email: 'invalid' | null
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const emptyWorkshopForm: WorkshopForm = {
  name: '',
  address: '',
  phone: '',
  email: '',
}

/**
 * `takenNames` are the other workshops' names, lowercased: the backend rejects
 * a duplicate name regardless of case.
 */
export function validateWorkshopForm(
  form: WorkshopForm,
  takenNames: string[]
): WorkshopFormErrors {
  const name = form.name.trim()
  const email = form.email.trim()

  return {
    name: !name
      ? 'required'
      : takenNames.includes(name.toLowerCase())
      ? 'taken'
      : null,
    email: email && !EMAIL_PATTERN.test(email) ? 'invalid' : null,
  }
}

export function trimWorkshopForm(form: WorkshopForm): WorkshopForm {
  return {
    name: form.name.trim(),
    address: form.address.trim(),
    phone: form.phone.trim(),
    email: form.email.trim(),
  }
}
